import styled from 'styled-components';

export const CardStyled = styled.div`
    width: 240px;
    height: 240px;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    background-color: ${({$isDark}) => ($isDark ? '#226b9c' : '#ffffff')};
    color: ${({$isDark}) => ($isDark ? '#ffffff' : '#1e5f8a')};
    border: ${({$isDark}) => ($isDark ? 'none' : '1px solid #e2e8f0')};
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    font-family: Arial, sans-serif;
    position: relative;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    }
`;

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  text-align: center;
  width: 100%;
`;

export const IconContainerStyled = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const TitleStyled = styled.h3`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  white-space: pre-line;
`;

export const FooterStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const InfoButtonStyled = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.9;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;